// import React,{Component} from "react";
// import {
//   Col,
//   Progress,
//   Input,
//   FormGroup,
//   Label
// } from "reactstrap";
// import "components/custom.css";
// import {store,persistor} from 'store/index';
// class Essay extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       question:"",
//       secondCount:1200,
//       questionId:"",
//       reset:false,
//       content:'',
//       lang:store.getState().user.lang,
//       copy:'',
//       resultObj:{},
//       correctFlag:true,
//       timeoutStat:false,
//       showTimer: true,
//     };
//   }
//   componentDidMount() {
//     const { isQuestionTime, questionTime, resultMode } = this.props;

//     if (isQuestionTime) {
//       this.setState({
//         secondCount: questionTime * 60,
//         showTimer: isQuestionTime,
//       });
//     }
    
//     if (!resultMode) {
//      const intervalId = setInterval(this.timer, 1000);
//      this.setState({ intervalId });
//     }
//   }


//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);

//         const { isQuestionTime, questionTime } = props;
//         let secondState = { secondCount: 1200, showTimer: true };
//         if (isQuestionTime) {
//           secondState = {
//             secondCount: questionTime * 60,
//             showTimer: isQuestionTime,
//           };
//         }

//   			//var intervalId = setInterval(ReadAloud.timer1, 1000);
//   			return {timeoutStat:false,correctFlag:true,...secondState,content:'',questionId: props.data.id,reset:true};
//   		}else{
//   			if (!state.questionId) {
//   				return {correctFlag:true,questionId: props.data.id,content:""};
//   			}
//   		}
//   	}
//   }

//   stopTest = () =>{
//     this.props.nextQuestion({...this.state.resultObj,time:this.state.secondCount});
//   }
//   copyToClipboard = () => {
//     document.execCommand("copy");
//   };

//   cutToClipboard = () => {
//     document.execCommand("cut");
//   };

//   pasteToClipboard = async () => {
//     alert("Press Ctrl+v for paste text");

//   };



// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);
//       this.setState({timeoutStat:true});
//       if (this.state.showTimer) {
//         this.props.nextQuestionHandler();
//       }
// 		}
// 		this.setState({ secondCount: this.state.secondCount -1 });
// 	}

// 	cleanString(input) {
// 	    let output = "";
// 	    for (let i = 0; i < input.length; i++) {
// 	        output += input.charCodeAt(i) <= 127 ? input.charAt(i) : ' ';
// 	    }
// 	    return output;
// 	}

//   chaneText = (e) => {
//     this.props.showResult();
//     let { name, value } = e.target;
// 	let clean_value = value.replace('”', '"');
// 	clean_value = this.cleanString(clean_value);
// 	// let clean_value = value;
//     this.props.submit({
// 		answer: clean_value,
// 		correct: '',
// 		length: clean_value.split(' ').filter(function(n) { return n != '' }).length,
// 		time: this.state.secondCount,
// 		lang: this.state.lang
// 	}, true);
//     this.setState({
// 		[name]: clean_value,
// 		resultObj: {
// 			answer: clean_value,
// 			correct: '',
// 			length: clean_value.split(' ').filter(function(n) { return n != '' }).length,
// 			time: this.state.secondCount,
// 			lang:this.state.lang
// 		}
// 	});
//   };

//   chaneLang = (e) => {
//     this.setState({lang:e.target.value});
//   }
//   updateCorrect = () =>{
//     this.props.submit({'answer':'','correct':'','length':0,time:this.state.secondCount,lang:this.state.lang});
//     this.setState({correctFlag:false,resultObj:{'answer':'','correct':'','length':0,time:this.state.secondCount,lang:this.state.lang}});
//   }
// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}

//   render() {
//   	let question ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//   	}
//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false});
//   	}
//     return (
//       <>
//         {!this.props.resultMode &&
//           <Col xs={12} className="text-right"><b><p><i className="fa fa-clock-o"></i> <span>Time Left: {Math.floor(this.state.secondCount / 60) +':'+ (this.state.secondCount % 60)}</span></p> </b></Col>
//         }
//       <Col xs={12}>
//       	<h4 className="infoText"></h4>
//       </Col>

//       <Col xs={12}><h5>{question}</h5></Col>
//       <Col xs={12}>
//       	<div className="col-lg-12 text-center">
// 		  <Col xs={12}>

// 		  </Col>

//       {!this.props.resultMode && !this.props.answer && <>
//         <Col xs={2} style={{margin:'10px'}}>

//         </Col>
//         <Col xs={12}>
//               <FormGroup>
//                 {!this.state.timeoutStat && <Input type="textarea" autoCorrect="false" spellCheck="false" name="content" id="textBox" onChange={(e) => { this.chaneText(e)} } value={this.state.content}  />}
//                 {this.state.timeoutStat && <div className="timeout-box">{this.state.content}</div>}
//               </FormGroup>
//               <div className="bottomContent">
//                 <p className="wordCount">Total word count: {this.state.content.split(' ').filter(function(n) { return n != '' }).length}</p>
//                 <div className="copyPaste">
//                   <a href="javascript:void(0)" onClick={this.cutToClipboard} className="btn">Cut</a>
//                   <a href="javascript:void(0)" onClick={this.copyToClipboard} className="btn">Copy</a>
//                   <a href="javascript:void(0)" onClick={this.pasteToClipboard} className="btn">Paste</a>
//                 </div>
//               </div>
//             </Col>

//             </>
//           }
// 		</div>
//       </Col>
//       </>
//     );
//   }
// }

// export default Essay;

import React, { useState, useEffect, useRef } from "react";
import ReactHtmlParser from "react-html-parser";
import {Col , Form} from "react-bootstrap";
import "components/custom.css";
import { store, persistor } from 'store/index';

const Essay = (props) => {
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(540);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [content, setContent] = useState('');
  const [lang, setLang] = useState(store.getState().user.lang);
  const [copy, setCopy] = useState('');
  const [resultObj, setResultObj] = useState({});
  const [correctFlag, setCorrectFlag] = useState(true);
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [intervalId, setIntervalId] = useState(null);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);

  // componentDidMount equivalent
  useEffect(() => {
    console.log("Essay of the Mock test")
    console.log("Here are the porper",props)
    const { isQuestionTime, questionTime, resultMode } = props;

    if (isQuestionTime) {
      setSecondCount(questionTime * 60);
      setShowTimer(isQuestionTime);
    }
    
    if (!resultMode) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
      intervalIdRef.current = id;
    }

    // componentWillUnmount equivalent
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
      if (recordIdRef.current) {
        clearInterval(recordIdRef.current);
      }
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);

        const { isQuestionTime, questionTime } = props;
        let secondState = { secondCount: 540, showTimer: true };
        if (isQuestionTime) {
          secondState = {
            secondCount: questionTime * 60,
            showTimer: isQuestionTime,
          };
        }

        setTimeoutStat(false);
        setCorrectFlag(true);
        setSecondCount(secondState.secondCount);
        setShowTimer(secondState.showTimer);
        setContent('');
        setQuestionId(props.data.id);
        setReset(true);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
          setContent("");
        }
      }
    }
  }, [props.data, props.restart, questionId, props.isQuestionTime, props.questionTime]);

  const stopTest = () => {
    props.nextQuestion({ ...resultObj, time: secondCount });
  };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  const cutToClipboard = () => {
    document.execCommand("cut");
  };

  const pasteToClipboard = async () => {
    alert("Press Ctrl+v for paste text");
  };

  const timer = () => {
    setSecondCount((prevCount) => {
      if (prevCount === 1) {
        clearInterval(intervalIdRef.current);
        setTimeoutStat(true);
        if (showTimer) {
          props.nextQuestionHandler();
        }
      }
      return prevCount - 1;
    });
  };

  const cleanString = (input) => {
    let output = "";
    for (let i = 0; i < input.length; i++) {
      output += input.charCodeAt(i) <= 127 ? input.charAt(i) : ' ';
    }
    return output;
  };

  const chaneText = (e) => {
    props.showResult();
    let { name, value } = e.target;
    let clean_value = value.replace('"', '"');
    clean_value = cleanString(clean_value);

    const wordCount = clean_value.split(' ').filter(function(n) { return n != '' }).length;
    const newResultObj = {
      answer: clean_value,
      correct: '',
      length: wordCount,
      time: secondCount,
      lang: lang
    };

    props.submit(newResultObj, true);
    
    setContent(clean_value);
    setResultObj(newResultObj);
  };

  const chaneLang = (e) => {
    setLang(e.target.value);
  };

  const updateCorrect = () => {
    const newResultObj = {
      'answer': '',
      'correct': '',
      'length': 0,
      time: secondCount,
      lang: lang
    };
    props.submit(newResultObj);
    setCorrectFlag(false);
    setResultObj(newResultObj);
  };

  // Handle reset logic
  useEffect(() => {
    if (reset) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
      intervalIdRef.current = id;
      setReset(false);
    }
  }, [reset]);

  // Render logic
  let question = "";
  if (props.restart) {
    props.restartQue();
  }
  // Handle stopRecording
  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);
  if (props.data) {
    question = props.data.question;
    if (correctFlag) {
      updateCorrect();
    }
  }

  const totalSeconds = Math.max(0, Math.floor(secondCount));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

 function Question({ questionText }) {
   return (
     <div className="write-email" style={{ paddingLeft: "20px" }}>
       {ReactHtmlParser(questionText)}
     </div>
   );
 }

  return (
    <>
      {!props.resultMode &&
        <Col xs={12} className="text-right"><b><p><i className="fa fa-clock-o"></i> 
        {/* <span>Time Left: {Math.floor(secondCount / 60) + ':' + (secondCount % 60)}</span> */}
        <span>Time Left: {minutes}:{seconds.toString().padStart(2, "0")}</span>
        </p> </b></Col>
      }
      <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>

      <Col xs={12}>
      <h5 className={props?.testMode ? "para-form" : "reading-text"}>
        <Question questionText={question} />
      </h5>
      </Col>
      <Col xs={12}>
        <div className="col-lg-12 text-center">
          <Col xs={12}>

          </Col>

          {!props.resultMode && !props.answer && <>
            <Col xs={2} style={{ margin: '10px' }}>

            </Col>
            <Col xs={12}>
              <div className="bottomContent test-editor-blue">
                <div className="copyPaste d-flex gap-2 mx-1 py-1">
                  <a href="javascript:void(0)" onClick={cutToClipboard} className="btn">Cut</a>
                  <a href="javascript:void(0)" onClick={copyToClipboard} className="btn">Copy</a>
                  <a href="javascript:void(0)" onClick={pasteToClipboard} className="btn">Paste</a>
                </div>
              </div>
              <Form.Group id="formGroupDiv">
                {!timeoutStat && <Form.Control as="textarea" autoCorrect="false" spellCheck="false" name="content" id="textBox" onChange={(e) => { chaneText(e) }} value={content} />}
                {timeoutStat && <div className="timeout-box">{content}</div>}
              </Form.Group>
              <div className="bottomContent test-editor-blue">
                <div className="copyPaste">
                <p className="wordCount text-white text-start p-2">Word Count: {content.split(' ').filter(function(n) { return n != '' }).length}</p>
                </div>
              </div>
            </Col>

          </>
          }
        </div>
      </Col>
    </>
  );
};

export default Essay;